module.exports = __webpack_public_path__ + "static/media/shailesh.9d658c18.png";